import { render, staticRenderFns } from "./myShare.vue?vue&type=template&id=77d3dcf2&scoped=true"
import script from "./myShare.vue?vue&type=script&lang=js"
export * from "./myShare.vue?vue&type=script&lang=js"
import style0 from "./myShare.vue?vue&type=style&index=0&id=77d3dcf2&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d3dcf2",
  null
  
)

export default component.exports